import React from 'react';
import PropTypes from 'prop-types';
import axios from '../lib/axios';

class UserExperiencePrompt extends React.Component {
  static propTypes = {
    community: PropTypes.string,
    email: PropTypes.string,
    uxPromptSubmissionUrl: PropTypes.string,
  };

  static defaultProps = {
    community: '',
    email: '',
    uxPromptSubmissionUrl: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      showing: true,
      intro: true,
      accepted: false,
      rejectionMessage: '',
    };
  }

  handleClose = () => {
    this.setState({ showing: false }, () => {
      axios
        .post(this.props.uxPromptSubmissionUrl, {
          accepted: false,
          message: this.state.rejectionMessage,
        });
    });
  };

  handleYes = () => {
    this.setState({ accepted: true }, () => {
      axios
        .post(this.props.uxPromptSubmissionUrl, { accepted: this.state.accepted })
        .then(this.setState({ intro: false }));
    });
  };

  handleNo = () => {
    this.setState({ intro: false });
  };

  handleRejectionMessageChange = e => {
    this.setState({ rejectionMessage: e.target.value });
  };

  submitPromptResults = e => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    axios
      .post(this.props.uxPromptSubmissionUrl, {
        accepted: this.state.accepted,
        message: this.state.rejectionMessage,
      })
      .then(this.handleClose());
  };

  renderIntroMessage() {
    const { community } = this.props;

    return (
      <div>
        <h3>Help us empower your community</h3>
        <p>
          We&apos;re working hard to support entrepreneurs like you, and want to know how we can do
          even better.
        </p>
        <p>
          Can you spare a few minutes to give feedback on improving the {community} online
          community? We&apos;ll follow up by email if so.
        </p>

        <div className="u-text-right">
          <button
            className="Button Button--small  u-mr-4"
            onClick={this.handleNo}>
            Not now
          </button>
          <button className="Button Button--small Button--primary" onClick={this.handleYes}>
            Yes! I want to help
          </button>
        </div>
      </div>
    );
  }

  renderAcceptanceMessage() {
    const { community, email } = this.props;

    return (
      <div>
        <h3>Thanks so much!</h3>
        <p>
          We&apos;ll reach you at {email} when we have new features for you to try out. You can
          reach us at any time via the <a href="https://help.union.vc">Help Center</a>.
        </p>

        <div className="u-text-right">
          <button className="Button Button--small Button--primary" onClick={this.handleClose}>
            Back to {community}
          </button>
        </div>
      </div>
    );
  }

  renderRejectionForm() {
    const { community } = this.props;

    return (
      <div>
        <h3>No problem!</h3>
        <p>
          Thank you for being part of the {community} community. If you have any feedback about your
          experience, please feel free to share.
        </p>

        <textarea
          rows="5"
          value={this.state.rejectionMessage}
          onChange={this.handleRejectionMessageChange}
        />

        <div className="u-text-right">
          <button
            className="Button Button--small  u-mr-4"
            onClick={this.submitPromptResults}>
            Back to {community}
          </button>
          <button
            className="Button Button--small Button--primary"
            onClick={this.submitPromptResults}>
            Submit
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.showing && (
          <div className="u-fixed u-inset-0 u-z-200">
            <div className="u-overlay u-cursor-pointer" onClick={this.handleClose} />
            <div className="u-relative u-max-w-md u-mx-auto u-flex u-items-center u-justify-center u-h-full u-pointer-events-none">
              <div className="u-m-2 sm:u-m-6 u-shadow u-bg-white u-rounded u-flex-1 u-pointer-events-auto u-overflow-hidden u-safari-border-radius-fix u-p-8">
                {this.state.intro && this.renderIntroMessage()}
                {!this.state.intro &&
                  (this.state.accepted
                    ? this.renderAcceptanceMessage()
                    : this.renderRejectionForm())}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UserExperiencePrompt;
